// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
//components
import { SimpleSlider } from "#/components/simple_slider/SimpleSlider";
import { Map } from "./map/Map";

/* import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-core.js";
import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-service.js";
import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-ui.js";
import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-mapevents.js";
import "../../../../components/haendlersuche/heremaps/js/mapjs-clustering"; */
//Api
import { Api } from "../../../../api";

@Component({
  mixins: [template],
  components: {
    SimpleSlider,
    Map,
  },
})
export default class ReadyToWork extends Vue {
  mapContainer;

  @Prop({ default: false })
  visible!: boolean;

  @Prop({
    default: () => {
      return {};
    },
  })
  public instance!: object;

  @Prop({ default: false })
  public useKonsiFilter!: boolean;

  sliderValues = [1, 2, 5, 10, 15, 20, 25, 50, 75, 100, 200, 250, 500, 1000];

  locationSelected = "";
  showMap = false;
  mapHeight = 0;
  lat = 0;
  lng = 0;

  myLocation: H.geo.IPoint | null = null;
  location: H.geo.IPoint | null = null;
  autoSuggestList: object[] = [];
  konsiPoints: H.geo.IPoint[] = [];

  radius = 1000;
  sliderValue: number | null = 1;

  created() {
    window.addEventListener("resize", this.handleResize);
    this.getPoints();
  }

  mounted() {
    this.mapContainer = <HTMLElement>this.$refs["map-container"];
  }

  get filterStore() {
    if (this.useKonsiFilter) {
      return this.$store.conversionWorldKonsiFilter;
    }

    return this.$store.conversionWorldProductFilter;
  }

  get isLocationActive() {
    return this.myLocation !== null;
  }

  private handleResize() {
    this.calcMapHeight();
  }

  private calcMapHeight() {
    if (window.innerWidth > 768) {
      this.mapHeight =
        window.innerHeight - this.mapContainer.getBoundingClientRect().top - 70;
    } else {
      this.mapHeight = 300;
    }
  }

  get isChecked() {
    return (
      this.filterStore.filter.ready_to_work &&
      this.filterStore.filter.ready_to_work.active
    );
  }

  public onCheckboxInput(value) {
    if (value) {
      if (!this.isChecked) {
        this.filterStore.addFilterTag("ready_to_work", {
          name: "Nur sofort verfügbare Fahrzeuge",
        });
      }
    } else {
      this.filterStore.removeFilterTag("ready_to_work", {
        name: "Nur sofort verfügbare Fahrzeuge",
      });
      this.locationSelected = "";
      this.showMap = false;
    }
    Vue.nextTick(() => {
      this.calcMapHeight();
    });
  }

  public handleSelectChange(value) {
    this.showMap = true;
    if (value != "myLocation") {
      Vue.nextTick(() => {
        let place: any = this.autoSuggestList[value];
        this.lat = place.position[0];
        this.lng = place.position[1];
        this.location = { lat: place.position[0], lng: place.position[1] };
        Vue.set(this.filterStore.filter.ready_to_work!, "location", {
          lat: place.position[0],
          lng: place.position[1],
        });
        this.calcMapHeight();
      });
    } else {
      Vue.nextTick(() => {
        this.lat = this.myLocation!.lat;
        this.lng = this.myLocation!.lng;
        this.location = this.myLocation;
        Vue.set(this.filterStore.filter.ready_to_work!, "location", {
          lat: this.lat,
          lng: this.lng,
        });
        this.calcMapHeight();
      });
    }
  }

  public onCurrentLocationButtonClick() {
    this.showMap = true;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        var point = new H.geo.Point(pos.coords.latitude, pos.coords.longitude);
        this.myLocation = point;
        this.lat = this.myLocation.lat;
        this.lng = this.myLocation.lng;
        this.location = this.myLocation;
        Vue.set(this.filterStore.filter.ready_to_work!, "location", {
          lat: this.lat,
          lng: this.lng,
        });
        this.locationSelected = "myLocation";
        Vue.nextTick(() => {
          this.calcMapHeight();
        });
      },
      (error) => {
        this.myLocation = null;
      }
    );
  }

  public onSearchOpen() {}

  public handleSearch(value) {
    if (value.length > 0) {
      Api.haendlersuche
        .autosuggest(value, this.lat, this.lng)
        .then((result) => {
          if (result && result.results && result.results.length > 0) {
            this.autoSuggestList = result.results;
          } else {
            this.autoSuggestList = [];
          }
        });
    } else {
      this.autoSuggestList = [];
    }
  }

  public clearSelection() {
    this.locationSelected = "";
    this.location = null;
    Vue.set(this.filterStore.filter.ready_to_work!, "location", undefined);
    this.sliderValue = null;
  }

  public onRangeChange(value) {
    this.radius = value * 1000;
    Vue.set(this.filterStore.filter.ready_to_work!, "radius", value);
    this.sliderValue = null;
  }

  private async getPoints() {
    let productId =
      this.$store.page.page!.route_parameter["productId"] || undefined;
    // @ts-ignore
    let konsi = await Api.conversionWorldService.getKonsiLocation({}, 0, 0);

    this.konsiPoints = konsi["locations"];
  }

  public onRadiusChange(radius) {
    this.sliderValue = radius;
    Vue.set(this.filterStore.filter.ready_to_work!, "radius", radius);
  }
}
